const settingsUtility = {
    methods: {
        getLoginStatus() {
            return window.localStorage.getItem("token") ? true : false;
        },
        setLogout() {
            window.localStorage.removeItem('reloaded');
            const reloaded = window.localStorage.getItem('reloaded');
            window.localStorage.removeItem('token');
            window.localStorage.removeItem('user');
            window.localStorage.removeItem('data');
            window.localStorage.removeItem('admin');
            if (reloaded !== 'true' && reloaded !== null) {
                window.localStorage.setItem('reloaded', 'true');
            }
            else {
                localStorage.setItem('reloaded', 'false');
            }
        },
        setLogin(data) {
            const { token, _id, isAdmin } = data;
            delete data['success'];
            localStorage.setItem('token', token)
            localStorage.setItem('user', _id)
            localStorage.setItem('data', JSON.stringify(data));
            window.localStorage.setItem("admin", isAdmin);
            window.localStorage.setItem('reloaded', 'false');
        },
        isAdmin() {
            const token =  window.localStorage.getItem("token");
            const isAdmin = window.localStorage.getItem("admin");
            return token && isAdmin === 'true' ? true : false;
        },
        getData() {
            const data = localStorage.getItem('data');
            return data ? JSON.parse(data) : null;
        },
        patchData(data) {
            const current = localStorage.getItem('data');
            if (current) {
                const newData = {
                    ...JSON.parse(current),
                    ...data
                };
                localStorage.setItem('data', JSON.stringify(newData));
            }
        }
    }
}
export default settingsUtility